import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta' 
import store from '../store'
import paths from './paths'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    // native-like behavior when navigating with back/forward buttons
    if (savedPosition) {
      return savedPosition
    }

    // scroll to anchor
    if (to.hash) {
      return { selector: to.hash }
    }

    // scroll to top
    return { x: 0, y: 0 }
  },
})

// Global Before Guard
// matched.some is to find which routes have requiresAuth
router.beforeEach((to, from, next) => { 
  to.matched.some(record => {
    if (to.path === '/login') {
      next()
      return
    }

    if (record.meta.requiresAuth) {
      if (!store.getters.authorized) {
        next('/login')
        return   
      }    
    }

    let userPermissions = store.state.permissions
    if (userPermissions.length <= 0) {
      store.dispatch('getUserPermissions')
        .then((response) => {
          userPermissions = response.data  

          let requiredPermission = record.meta.permission
          if (!requiredPermission) {
            next()
            return
          }
      
          let hasPermission = userPermissions.find(perm => perm.name === requiredPermission)
          if (!hasPermission) next('/permissions/deny')
        })
        .catch(() => {
          next()
        })
    } else {
      let requiredPermission = record.meta.permission
      if (!requiredPermission) {
        next()
        return
      }
  
      let hasPermission = userPermissions.find(perm => perm.name === requiredPermission)
      if (!hasPermission) next('/permissions/deny')
    }
  })
})

Vue.use(Meta)

export default router
